import { inject, injectable } from 'inversify'
import symbols from '../../symbols'
import {
  FetchAnswersUseCaseInput,
  FetchAnswersUseCaseOutput,
  IAnswerBase,
  IAppErrorFactory,
  IFetchAnswersUseCase,
  IQuestionsService,
  IUseCaseOutputFactory,
} from '../../types'

@injectable()
export default class FetchAnswersInteractor implements IFetchAnswersUseCase {
  @inject(symbols.IQuestionsService) private questionsService: IQuestionsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  @inject(symbols.IUseCaseOutputFactory) private outputFactory: IUseCaseOutputFactory<{
    answers: null | IAnswerBase[]
    hasNextPage: null | boolean
  }>

  async handle(input: FetchAnswersUseCaseInput): Promise<FetchAnswersUseCaseOutput> {
    const output = this.outputFactory.create({
      defaultValue: {
        answers: null,
        hasNextPage: null,
      },
    })
    try {
      const result = await this.questionsService.fetchAnswers(input)

      let { answers } = result
      // TODO: Question と Answer を Entity に変更し、デフォルトを 空配列にする。
      if (answers?.length > 0) {
        answers = answers.map((answer) => {
          return {
            ...answer,
            childReplies: [],
          }
        })
      }
      output.data.answers = answers
      output.data.hasNextPage = result.hasNextPage
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
      })
    }

    return output
  }
}
